// extracted by mini-css-extract-plugin
module.exports = {"rejectButton":"reject_handshake-module_rejectButton_b461e"};